/** @jsxRuntime classic */
/** @jsx jsx */
import { useMemo } from 'react';
import { css, jsx } from '@emotion/react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useStore, MEETING_ASIDE_OPEN } from '../store';
import { useClientLanguages } from '../utils/hooks';
import Link from '@mui/material/Link';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { IS_SINGLE_TENENT_MODE, HOMEPAGE_URL } from '../constants';
import Select from './common/Select';

export default function PublicHeader({
  guestPage = false,
  isTablet,
  isMobile,
  showLanguageSelector = true,
  showSignupLinks = false,
  showLoginLinks = false,
}) {
  const clientLanguages = useClientLanguages();
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const insideMeeting = location.pathname.startsWith('/transcript');
  const [meetingAsideOpen, setMeetingAsideOpen] = useStore(MEETING_ASIDE_OPEN);
  let headerCss;
  if (guestPage) {
    headerCss = css`
      display: flex;
      height: var(--header-height);
      background-color: transparent;
      box-sizing: border-box;
      padding: 8px;
      justify-content: space-between;
      align-items: center;
      padding-right: 1rem;
    `;
  } else {
    headerCss = css`
      width: 100%;
      margin-top: 2rem;
      background-color: var(--background-white);
      display: flex;
    `;
  }

  const language = useMemo(() => {
    const _lang = i18n.language;
    if (_lang.includes('-')) {
      return _lang.split('-')[0];
    }
    return _lang;
  }, [i18n.language]);

  return (
    <div css={headerCss}>
      <Link href={HOMEPAGE_URL} underline="hover">
        <img
          src={
            !IS_SINGLE_TENENT_MODE ? '/logo_long.svg' : '/tenent_logo_long.jpg'
          }
          alt="Logo"
          css={css`
            height: 2.25rem;
            margin-left: 2rem;
          `}
        />
      </Link>
      {insideMeeting && isTablet ? (
        <IconButton onClick={() => setMeetingAsideOpen(!meetingAsideOpen)}>
          <InfoOutlinedIcon />
        </IconButton>
      ) : null}
      {showSignupLinks ? (
        <div
          css={css`
            margin-left: auto;
            margin-right: 2rem;
            display: flex;
            gap: 0.5rem;
          `}
        >
          {!isMobile ? (
            <Link href="https://klang.ai/support/" underline="hover">
              <Button variant="text">{t('Kontakta försäljning')}</Button>
            </Link>
          ) : null}
          <Link href="/login" underline="hover">
            <Button variant="text">{t('Logga in')}</Button>
          </Link>
        </div>
      ) : null}
      {!IS_SINGLE_TENENT_MODE && showLoginLinks ? (
        <div
          css={css`
            margin-left: auto;
            margin-right: 2rem;
            display: flex;
            gap: 0.5rem;
          `}
        >
          {!isMobile ? (
            <Link href="https://klang.ai/support/" underline="hover">
              <Button variant="text">{t('Kontakta försäljning')}</Button>
            </Link>
          ) : null}
          <Link href="/signup" underline="hover">
            <Button variant="contained">{t('Skapa konto')}</Button>
          </Link>
        </div>
      ) : null}
      {showLanguageSelector ? (
        <Select
          css={css`
            margin-left: auto;
            margin-right: ${guestPage ? '0rem' : '2rem'};
          `}
          size="small"
          options={clientLanguages}
          value={language}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
        />
      ) : null}
    </div>
  );
}
